import React from 'react';

export const WordIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#2B579A" />
    <text x="8" y="11.8" textAnchor="middle" fill="white" fontSize="10" fontWeight="700"
      fontFamily="Segoe UI, Arial, Helvetica, sans-serif" style={{ letterSpacing: '-0.5px' }}>W</text>
  </svg>
);

export const PdfIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#E2574C" />
    <text x="8" y="11.2" textAnchor="middle" fill="white" fontSize="6.5" fontWeight="700"
      fontFamily="Arial, Helvetica, sans-serif" style={{ letterSpacing: '0.3px' }}>PDF</text>
  </svg>
);

export const ExcelIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#217346" />
    <text x="8" y="11.8" textAnchor="middle" fill="white" fontSize="10" fontWeight="700"
      fontFamily="Segoe UI, Arial, Helvetica, sans-serif">X</text>
  </svg>
);

export const TextIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#6B7280" />
    <text x="8" y="11.6" textAnchor="middle" fill="white" fontSize="9" fontWeight="700"
      fontFamily="Arial, Helvetica, sans-serif">TXT</text>
  </svg>
);

export const ImageIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#7C3AED" />
    <circle cx="6" cy="6.5" r="1.5" fill="white" opacity="0.9" />
    <path d="M2.5 11.5L5.5 8L7.5 10.5L9.5 7.5L13.5 11.5V13H2.5V11.5Z" fill="white" opacity="0.9" />
  </svg>
);

export const EpubIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#8B5CF6" />
    <path d="M4 3.6c0-.4.3-.7.7-.7h2.6c.3 0 .5.1.7.3.2-.2.4-.3.7-.3h2.6c.4 0 .7.3.7.7v7.3c0 .4-.3.6-.7.5a4 4 0 0 0-2.6.1l-.7.3-.7-.3a4 4 0 0 0-2.6-.1c-.4.1-.7-.1-.7-.5V3.6Z" fill="white" opacity="0.92" />
    <path d="M8 4v7.3" stroke="#8B5CF6" strokeWidth="0.7" />
  </svg>
);

export const GenericFileIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="#9CA3AF" />
    <rect x="4" y="4.5" width="8" height="1.2" rx="0.6" fill="white" opacity="0.8" />
    <rect x="4" y="7.4" width="8" height="1.2" rx="0.6" fill="white" opacity="0.8" />
    <rect x="4" y="10.3" width="5.5" height="1.2" rx="0.6" fill="white" opacity="0.8" />
  </svg>
);
